import moment from "moment";

// Resolves a (year, 0-based month) selection to the last calendar day of that
// month at midnight — the value submitted as InsurerReportDate on import.
// The backend's CustomDateTimeConverter parses exactly "yyyy-MM-ddTHH:mm:ss".
export const resolveInsurerReportDate = (
  year: number,
  month0: number
): string => {
  return moment()
    .year(year)
    .month(month0)
    .endOf("month")
    .startOf("day")
    .format("YYYY-MM-DDTHH:mm:ss");
};

// Whether a matched entry's amount/rate differs from its payment / payment-plan
// counterpart (used to flag the field in red). Only meaningful for matched entries.
export const isEntryMatched = (entry: {
  paymentId: number | null;
  paymentPlanEntryId: number | null;
}): boolean => entry.paymentId !== null || entry.paymentPlanEntryId !== null;

// Matched / unmatched counts of a report's loaded entries, used to keep the master
// row's counters in step after a manual (un)match without a reload.
export const countMatchedInsurerReportEntries = (
  entries: Array<{
    paymentId: number | null;
    paymentPlanEntryId: number | null;
    isDeleted?: boolean;
  }>
): { entryCount: number; matchedEntryCount: number; unmatchedEntryCount: number } => {
  const live = entries.filter((entry) => entry.isDeleted !== true);
  const matchedEntryCount = live.filter(isEntryMatched).length;
  return {
    entryCount: live.length,
    matchedEntryCount,
    unmatchedEntryCount: live.length - matchedEntryCount,
  };
};

// Stricter than isEntryMatched: for columns sourced only from the matched
// installment there is nothing to compare when the entry is cleared through a
// payment instead, so those must not be flagged.
export const hasPaymentPlanEntry = (entry: {
  paymentPlanEntryId: number | null;
}): boolean =>
  entry.paymentPlanEntryId !== null && entry.paymentPlanEntryId !== undefined;
